import(/* webpackMode: "eager" */ "/vercel/path0/app/articles/best-nextjs-boilerplate-for-b2c-marketplaces-2025/page.tsx");
